import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControlStatus } from '@angular/forms';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { ContactUI } from '@src/models';
import { Nullable, Optional } from '@src/types/utils';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ContactsComponent extends AbstractTuiControl<Array<ContactUI>> {
  @Input() loading = false;
  @Input() allowCreating: Optional<Nullable<boolean>> = false;
  @Input() allowEditing: Optional<Nullable<boolean>> = false;
  @Input() allowDeleting: Optional<Nullable<boolean>> = false;
  @Input() allowFilesDeleting: Optional<Nullable<boolean>> = true;
  @Input() isModeration: Optional<Nullable<boolean>> = false;
  @Input() showFieldCounter: Optional<Nullable<boolean>> = true; // TODO: Убрать и использовать allowEditing
  @Input() showFieldSeparator: Optional<Nullable<boolean>> = true; // TODO: Убрать и использовать allowEditing
  @Input() showFieldValue: boolean = true;

  @Input() set acceptFiles(value: Optional<Array<string>>) {
    this.accept = value ? value.join(',') : '';
  }
  @Input() contactMaxLength: number = 2000;
  @Input() descriptionMaxLength: number = 2000;

  accept = '';

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): Array<ContactUI> {
    return [];
  }

  protected onStatusChange(status: FormControlStatus) {
    if (status === 'INVALID') {
      this.control?.setErrors({ contactsInvalid: true });
    } else if (this.control?.errors && this.control.hasError('contactsInvalid')) {
      delete this.control.errors['contactsInvalid'];
    }
  }
}
